CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Control_ProgressManager, },
], () => {
    $(document).ready(function () {
        let lightdiv = $("<div class='light' style='width: 400px;padding:10px;'>");
        $("body").append(lightdiv);

        let progressManager = new CDN.Controls.ProgressManager(lightdiv, {
            title: "Test Title - downloading...",
        });

        for (let i = 0; i < 4; i++) {
            progressManager.addProgressBar({
                values: {
                    val: 0,
                    min: 0,
                    max: 100,
                },
                text: {
                    left: (value, data) => {
                        return `${value.val}/${value.max}`;
                    }
                },
                buttons: [
                    {
                        type: "cancel",
                        actionInitiated: () => {
                            return confirm(`Are you sure you wish to cancel item ${i}`);
                        },
                    }
                ],
            });
        }
    });
});